export default {
  ANALYTICS: {
    TRACKER_ID: 'UA-78663608-1',
  },
  AIRFLOW_URL: 'https://release-af.optimization.choreograph.com',
  MAPBOX_PUBLIC_TOKEN: 'pk.eyJ1IjoieGF4Y29waWxvdGVuZ2luZWVycyIsImEiOiJja2JsYjFmN2swMGY4MnFwNm5ycWRqcjl2In0.XHZYI6eDOPj8cjMfS9Exvg',
  ENV: 'release',
};
